import { render, staticRenderFns } from "./spotWallet.vue?vue&type=template&id=2387b203&scoped=true"
import script from "./spotWallet.vue?vue&type=script&lang=ts"
export * from "./spotWallet.vue?vue&type=script&lang=ts"
import style0 from "./styles/finrez.scss?vue&type=style&index=0&id=2387b203&prod&lang=scss&scoped=true&external"
import style1 from "./spotWallet.vue?vue&type=style&index=1&id=2387b203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387b203",
  null
  
)

export default component.exports